import { lazyNamed } from 'src/utils/lazyNamed';

export const Availabilities = {
  List: lazyNamed(() => import('./containers/AvailabilitiesList'), 'AvailabilitiesList'),
};
